import React, {useEffect, useState} from 'react';
// import { Slider, Button, Brands } from "../components";
import StarWhite from "../img/star-white.svg";
import StarYellow from "../img/star-yellow.svg";
import Temi from "../img/temidayo.png";
import Name from "../img/name.svg";
import Marquee from "react-fast-marquee";
import { Button } from "../components";
import Arrow from "../img/arrow-circle-down.svg";

import { brandlogos, testimonials} from "../utils/constants"

import {Link} from "react-router-dom"
import { Slide } from "react-slideshow-image";




const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

  }, []);

  
  const words = ["TEMIDAYO", "A DESIGNER"];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((index + 1) % words.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [index, words.length]);


  const marqueeOne = {
    pauseOnHover: true,
    direction: "left",
    speed: 100,
    gradient: false

  }

  const marqueeTwo = {
    pauseOnHover: true,
    direction: "right",
    speed: 100,
    gradient: false

  }

  const marqueeThree = {
    pauseOnHover: true,
    direction: "right",
    speed: 50,
    gradient: false

  }
  const buttonStyle = {
    width: "30px",
    background: 'none',
    border: '0px'
};

  const SlideProperties = {
    duration: 2000,
    transitionDuration: 400,
    infinite: true,
    scale: 0.7,
    arrows: true,
    slidesToShow: 1,
    canSwipe: true,
    prevArrow: <button style={{ ...buttonStyle }}><svg width="30" height="36" viewBox="0 0 30 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M-8.74228e-07 18L30 0.679488L30 35.3205L-8.74228e-07 18Z" fill="#FFCC00"/>
    </svg>
    </button>,
    nextArrow: <button style={{ ...buttonStyle }}><svg width="30" height="36" viewBox="0 0 30 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M30 18L-1.63133e-06 35.3205L-1.17124e-07 0.67949L30 18Z" fill="#FFCC00"/>
    </svg>
    </button>
  };




  return (
    <>
       <section className={`bg-black px-8 pt-40 md:pt-60 mt-[1px] text-center  lg:px-16  pb-10`}>
        <div className={`text-[80px] md:text-[128px] md:leading-[151.81px] text-white mb-5`}>
          <Marquee  {...marqueeOne}>
            <span className={`flex items-center `} style={{fontFamily: ' macklin'}}>
              <div>Everything is designed</div> 
              <img className={`w-10 h-10 mx-4`} src={StarYellow} alt="" />
           
            </span>
         </Marquee>
        </div>
        <div className={`text-[80px] md:text-[128px] md:leading-[151.81px] text-primary`}>
          <Marquee  {...marqueeTwo} >
            <span className={`flex items-center`} style={{fontFamily: ' macklin'}}>
              <div>Few things are designed Well</div> 
              <img className={`w-10 h-10 mx-4`} src={StarWhite} alt="" />
           
            </span>
         </Marquee>
        </div>
      </section>

   

      <section className="bg-black px-8 py-10 -mt-[1px] lg:px-16">
        <div className="h-[0.5px] bg-[#f5f5f5]" />
        <div className="flex flex-col md:flex-row pt-8">
          <div className="text-white text-left md:text-left md:w-[70%] ">
            <div className="headings text-[32px] font-bold leading-[39px] md:text-[50px] md:leading-[60px] lg:text-[96px] lg:leading-[99px]">
              <h1>HI THERE!</h1>
              <h1>
                I'M <span className="text-primary animate-flip duration-2000 ">  {words[(index + 1) % words.length]}</span>
              </h1>
            </div>
            <p className="text-[22px] leading-[36px] font-medium mb-4 md:w-[70%]">
              I create Next-Level Visual Content. My Design Forte are Brand
              Identity and Advertising Design. I’m Passionate about Growth and
              i've offered Visual Solutions to Brands for Half a Decade.
            </p>
          </div>


          <div className="flex-1 self-center lg:p-10 md:pt-0">
                <div className="relative flex items-center justify-center h-auto">
                <img src={Name} alt="" className="animate-spin-slow"/>
                <img className={`w-[80%] absolute  md:w-[80%] rounded-full  md:ml-auto  md:items-center`} src={Temi} alt="" /> 
                  </div>
        </div>


        </div>


      
      </section>

      <section className='bg-black px-8 py-10 -mt-[1px] lg:px-16 text-white flex justify-center'>
        <div className="">
       
        <h1 className="text-center md:text-[64px] text-[34px] md:leading-[78.72px] font-semibold">I design for the bests in their fields&nbsp;</h1>
        
        </div>
      
      </section>

      <section className='bg-black px-8 py-10 -mt-[1px] lg:px-16 text-white flex justify-center'>
         <Marquee {...marqueeThree}>
       <div className='flex gap-4 '>
       {brandlogos.map((brandlogo, i) => (
        <div key={i} className="border p-10 text-white flex items-center">
          <img src={brandlogo.img} alt="" className=" md:w-full" />
  
        </div>
       ))}&nbsp;
       </div> 
       </Marquee>

    
      
      </section>


      <section className='bg-black px-8 py-10 -mt-[1px] lg:px-16 text-white flex justify-center'>
        <div className=' w-full md:w-[80%]'>
      
        <h1 className=" text-[34px] md:text-[64px] md:leading-[78.72px] font-semibold text-center pb-10">What my clients say</h1>



<div className="slide-container">
      <Slide {...SlideProperties}>
        {testimonials.map((testimonial, index) => (
          <div className="md:px-[80px] text-center text-white gap-10 ">
          <div className="space-y-8">
          <h1 className="text-[18px] md:text-[32px] leading-[39.36px]">{testimonial.review}</h1>
          <p className="text-[18px]  md:text-[32px] leading-[39.36px] font-bold">{testimonial.fullname}</p>
          </div>
          </div>
        ))}
      </Slide>
    </div>
 
        </div>
      
      </section>

      <section className="bg-black px-8 py-10 -mt-[1px] lg:px-16">
        <div className="h-[0.5px] bg-[#f5f5f5]" />
        <div className="grid  grid-cols-1 lg:grid-cols-2 py-8">
          <div className="text-white">
            <div className="headings text-[32px] md:text-[64px] md:leading-[96px] text-left pb-4 md:pb-0">
              <h1> <span className="italic font-bold">DIVE &nbsp;</span>INTO MY</h1>
              <h1>
                WORLD OF <span className="italic font-bold">MAGIC</span>
              </h1>
            </div>
           
          </div>
       
          <div className="justify-start md:ml-auto flex md:self-end">
          <Link to="/showcase">
            <Button text="Go to Showcase" to="/showcase" src={Arrow} />
            </Link>
          </div>
        
         
        </div>
        <div className="h-[0.5px] bg-[#f5f5f5]" />
      </section>
    </>
  )
}

export default About